'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX modules
import DeliveryOptionIcon from './delivery-option-icon';
import WarningMessage from '../../_utils/warning-message';

const DeliveryOptionsList = ({ options, product, selectedDeliveryOptions }) => {
  const filterOptions = (options, selection) => {
    var result = [];
    for (var key in selection) {
      for (var index in options) {
        if (options[index]['key'] === selection[key]) {
          result.push(options[index]['title'].replace(/\s+\([^}]*\)/g, ''));
        }
      }
    }
    return result.join(', ');
  };
  const renderWarning = () => {
    if (product && selectedDeliveryOptions) {
      const splitDeliveryOptions = selectedDeliveryOptions.split('|');
      const validDelivery = product.delivery_options.some(option =>
        splitDeliveryOptions.includes(option.toString())
      );
      if (!validDelivery) {
        const toBe = splitDeliveryOptions.length > 1 ? 'are' : 'is';
        const filteredOptions = filterOptions(options, splitDeliveryOptions.map(ele => parseInt(ele)));
        const deliveryWarning = `${filteredOptions} ${toBe} not available for selected product.`;
        return (
          <WarningMessage isWarning hidePrefix isDelivery className="">
            <i className="fa fa-info-circle" />
            {deliveryWarning}
          </WarningMessage>
        )
      }
    }
  }

  return (
    <>
      {renderWarning()}
      <div className="delivery-options-list">
        {options.map((option, i) => {
          const available =
            product && product.delivery_options.some(id => id == option.key),
            unavailable = !available;
          return (
            <div
              key={i}
              className={classNames('delivery-option', {
                available,
                unavailable,
              })}>
              <DeliveryOptionIcon
                option={option}
                selectedDeliveryOptions={selectedDeliveryOptions}
                unavailable={unavailable}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

DeliveryOptionsList.displayName = 'Delivery Options List';

export default DeliveryOptionsList;
